export function truncateKey(key: string, showLength: number = 8): string {
	if (!key || key.length < showLength * 2) return key;
	return `${key.substring(0, showLength)}...${key.substring(key.length - showLength)}`;
}
